






























import Vue, { PropType } from 'vue';
import { v4 } from 'uuid';

export default Vue.extend({
  props: {
    isLabel: { type: Boolean as PropType<boolean>, default: true },
    isTag: { type: Boolean as PropType<boolean>, default: false },
    isPublic: { type: Boolean as PropType<boolean>, default: false },
    exclamation: { type: Array as PropType<string[]>, default: () => [] },
    value: { type: Array as PropType<string[]>, default: () => [] },
    name: { type: String as PropType<string>, required: true },
    label: { type: String as PropType<string>, required: true },
    rows: { type: Number as PropType<number>, default: 3 },
    placeholder: { type: String as PropType<string>, default: '' },
    disabled: { type: Boolean as PropType<boolean>, default: false },
    maxLength: { type: Number as PropType<number>, default: 0 },
    isRequired: { type: Boolean as PropType<boolean>, default: false },
    underline: { type: Boolean as PropType<boolean>, default: false },
    rules: { type: [String, Object] as PropType<string | object>, default: '' },
  },
  computed: {
    vid(): string {
      return `${this.name}:${v4()}`;
    },
    innerValue: {
      get(): string {
        return this.value.join('\n');
      },
      set(val: string): void {
        const ls = val
          .split('\n')
          .map((l) => l.replace('\t', '').trim())
          .filter((l) => l.length > 0);
        this.$emit('input', ls);
      },
    },
  },
  methods: {
    validate() {
      (this.$refs.gTextareaFormProvider as any).validate();
    },
  },
});
